import { requestHelpers } from '../../helpers';
const actions = {
    GET_EXPERTISE: "GET_EXPERTISE",
    SET_EXPERTISE: "SET_EXPERTISE",
};
function getExpertise() {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_EXPERTISE,
        } );
        requestHelpers
            .authenticatedGetRequest( '/common/job/expertise' )
            .then( ( response ) => {
                const siteOfOrigin = localStorage.getItem( 'site_of_origin' );
                dispatch( {
                    type: actions.SET_EXPERTISE,
                    expertise: siteOfOrigin === 'us' ? response.data.us : response.data.uk,
                } );
            } );
    };
}
module.exports = {
    actions,
    getExpertise
}


// WEBPACK FOOTER //
// src/client/actions/common/expertise.js